<template>
  <div class="terms-footer">
    <div class="terms-footer__line">By continuing you agree to the</div>
    <span class="terms-footer__link" @click="onTsAndCsClicked">Terms &amp; Conditions</span>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'TermsFooter',
  computed: {
    ...mapState(['brandConfig'])
  },
  methods: {
    onTsAndCsClicked() {
      window.open(this.brandConfig.termsAndConditionsUrl, '_blank');
    }
  }
}
</script>

<style scoped>
.terms-footer {
  text-align: center;
  /* Set on the container so the anonymous line box wrapping the link inherits it
     too — otherwise the link's own line-height is ignored and the two lines drift. */
  line-height: 16.4px;
}

.terms-footer__line {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
}

.terms-footer__link {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
  text-decoration: underline;
  text-decoration-thickness: 0.6px;
  text-underline-offset: 1.2px;
  cursor: pointer;
}
</style>
